import React, { Fragment, useEffect, useRef, useMemo } from 'react'
import useStyles from './styles'
import Bid from './Bid'
import { orderBy } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import {
  Typography,
  CircularProgress,
  Box,
  useMediaQuery
} from '@material-ui/core'
import { getItemBids } from 'actions/items'
import classnames from 'clsx'
import Scrollbars from 'react-scrollbars-custom'
import AutoSizer from 'react-virtualized-auto-sizer'

const BidList = ({ item, scrollable = true, scrollEffect = false }) => {
  const classes = useStyles()
  const listRef = useRef(null)

  const isMobile = useMediaQuery('(max-width: 767px)')

  const bidsLoading = useSelector(state => state.items.bidsLoading)
  const bids = useSelector(state => state.items.bids)
  const items = useSelector(state => state.items.items)
  const thisItem = items.find(i => i.item_id === item.item_id)

  const dispatch = useDispatch()

  const updateScroll = () => {
    listRef.current.scrollTop = listRef.current.scrollHeight
  }

  useEffect(() => {
    if (bids === null) {
      dispatch(getItemBids(item.item_id)).then(() => {
        // updateScroll()
      })
    } else {
      // updateScroll()
    }
  }, [])

  const renderThumbVertical = ({ style, ...props }) => {
    return (
      <div style={{ ...style }} className={classes.scrollThumb} {...props} />
    )
  }

  const orderedBids = useMemo(() => {
    return orderBy(bids, 'bid_amt', 'desc')
  }, [bids])

  return (
    <Fragment>
      {bids && bids.length > 0 && (
        <Box className={classes.bidListScrollArea}>
          <AutoSizer>
            {({ height, width }) => (
              <Scrollbars
                ref={listRef}
                style={{
                  height: height - 1,
                  width
                }}
                noScroll={!scrollable || isMobile}
                removeTracksWhenNotUsed
                disableTracksWidthCompensation
              >
                {orderedBids.map((bid, i) =>
                  i > 0 ? (
                    <Bid
                      key={bid.bid_id}
                      bid={bid}
                      scrollEffect={scrollEffect}
                      parentRef={listRef}
                    />
                  ) : null
                )}
              </Scrollbars>
            )}
          </AutoSizer>
        </Box>
      )}
      {!bids && bidsLoading && (
        <div className={classes.bidsLoading}>
          <Typography variant="h4" className={classes.loadingTypography}>
            Loading Bids
          </Typography>
          <CircularProgress />
        </div>
      )}
      {!bids && !bidsLoading && (
        <Typography variant="h4" className={classes.noBidsTypography}>
          No Bids Have Been Placed Yet
        </Typography>
      )}
    </Fragment>
  )
}

export default BidList



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/BidList/index.jsx